<template>
  <div class="Learn">

    <learn-component :items="items" v-if="items" />

  </div>
</template>

<script>
import LearnComponent from 'components/Learn/Learn'

export default {
  name: 'Learn',

  components: {
    LearnComponent
  },

  created () {
    this.$nextTick(() => {
      this.$store.dispatch('showCircleBorder', true)
    })
  },

  beforeDestroy () {
    this.$store.dispatch('showCircleBorder', false)
  },

  computed: {
    surveys () { return this.$store.state.animal.surveys },

    items () {
      if (!this.surveys) return

      const items = []
      let questionTypeCounter = 0

      // Translate question 'types' from API to app templates
      const templates = {
        'QuestionMultipleChoice': 'multiple-choice',
        'QuestionTrueFalse': 'true-false',
        'DotIllustration': 'pop-up',
        'TouchPointSlider': 'slider',
        'TouchPointCircleSlider': 'slider'
      }

      // These template types pose a question
      const questionTemplate = [
        'QuestionMultipleChoice',
        'QuestionTrueFalse'
      ]

      // Each template type that is presented as a question has a supertitle
      // like 'Learn: Question One'. Up to twenty are supported.
      const numbers = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eightteen', 'nineteen', 'twenty']

      this.surveys.forEach((survey, index) => {
        let supertitle = 'Learn'

        // Check if this template is presented as a question
        if (questionTemplate.includes(survey.type)) {
          // If so, adjust the supertitle
          supertitle += `: Question ${numbers[questionTypeCounter]}`
        }

        // Create question item
        const questionObj = {
          id: survey.id,
          template: templates[survey.type],
          question: true,
          content: {
            supertitle: supertitle,
            title: survey.title,
            text: survey.text,
            image: survey.questionImage || survey.image,
            options: survey.options
          }
        }

        // Adding continue buttons to questions without answers
        if (['pop-up', 'slider'].includes(questionObj.template)) {
          questionObj.buttons = [ { label: 'Continue' } ]
        }

        // Add 'revealer' components for sliders
        if (survey.type === 'TouchPointSlider') {
          questionObj.content.options.forEach(option => {
            option.type = 'revealer'
          })

          questionObj.content.footer = 'Swipe to see additional pets.'
        }

        // Add 'revealer' components for flippers
        if (survey.type === 'TouchPointCircleSlider') {
          questionObj.content.options.forEach(option => {
            option.type = 'flipper'
          })

          questionObj.content.footer = 'Swipe to explore additional recommendations.'
        }

        items.push(questionObj)

        // Handle multiple choice answer
        if (templates[survey.type] === 'multiple-choice') {
          items.push({
            template: 'bar-chart',
            buttons: [ { label: 'Continue' } ],
            content: {
              supertitle: `Learn: Answer ${numbers[questionTypeCounter]}`,
              title: survey.title,
              image: survey.answerImage,
              options: survey.options
            }
          })
        }

        // Handle true false answer
        if (templates[survey.type] === 'true-false') {
          items.push({
            template: 'answer-text',
            buttons: [ { label: 'Continue' } ],
            content: {
              supertitle: `Learn: Answer ${numbers[questionTypeCounter]}`,
              title: survey.title,
              text: survey.answerDescription,
              image: survey.answerImage
            }
          })
        }

        // Check if this template is presented as a question
        if (questionTemplate.includes(survey.type)) {
          // Increment questionTypeCounter
          questionTypeCounter++
        }
      })

      // Last item button should say 'Start Over'
      items[items.length - 1].buttons[0].label = 'Start Over'

      return items
    }
  }
}
</script>



// WEBPACK FOOTER //
// Learn.vue?342c2d6d